import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
export const Etiket = forwardRef(({ className, ...rest }, ref) => (_jsx("label", { ref: ref, className: cn('text-fume-700 dark:text-fume-300 select-none text-sm font-medium', className), ...rest })));
Etiket.displayName = 'Etiket';
//# sourceMappingURL=etiket.js.map